import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";
// import ProductSection from "./ProductSection";
import { useEffect, useState } from "react";
import { getData } from "../../../utils/api";
import { Select2Data, variant_type } from "../../../utils/common";
import TripleVarientSection from "./TripleVarient";

const DoubleVarientSection = ({
  product_id,
  Index,
  control,
  register,
  getValues,
  errors,
  setValue,
  DoubleVariants,
  SIndex,
}) => {
  

  return (
    <>
      {DoubleVariants?.map((dvariant, DIndex) => (
        <div key={dvariant.value} className="border p-3 mb-3">
          <Row>
            <h5>
              {product_id?.d_variant_name || "Double Variant"} {DIndex + 1}
            </h5>

            {/* Hidden field to store varient_id */}
            <Controller
              control={control}
              name={`products.${Index}.varients.${SIndex}.double_variants.${DIndex}.d_variant_id`}
              defaultValue={dvariant?.id}
              render={({ field }) => <input type="hidden" {...field} />}
            />

            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  {product_id?.d_variant_name || "Double Variant"}
                </Form.Label>

                <Form.Control
                  type="text"
                  value={dvariant.Size?.name}
                  readOnly
                />
              </Form.Group>
            </Col>

            {Number(product_id?.variant_type_id) === variant_type.Double && (
              <>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Selling Price</Form.Label>
                    <Controller
                      control={control}
                      name={`products.${Index}.varients.${SIndex}.double_variants.${DIndex}.selling_price`}
                      defaultValue={dvariant.price}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          readOnly
                          placeholder="Selling Price"
                          isInvalid={
                            !!errors?.products?.[Index]?.varients?.[SIndex]
                              ?.double_variants?.[DIndex]?.selling_price
                          }
                        />
                      )}
                    />
                    <Form.Control.Feedback type="invalid">
                      {
                        errors?.products?.[Index]?.varients?.[SIndex]
                          ?.double_variants?.[DIndex]?.selling_price?.message
                      }
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Purchase Price</Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="Price"
                      {...register(
                        `products.${Index}.varients.${SIndex}.double_variants.${DIndex}.price`,

                        {
                          required: "Price is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        },
                      )}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        // Allow only control keys and digits (0–9)
                        if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                          return;
                        }

                        // Prevent decimal points or anything else
                        e.preventDefault();
                      }}
                    />

                    {errors?.products?.[Index]?.varients?.[SIndex]
                      ?.double_variants?.[DIndex]?.price && (
                      <span className="text-danger">
                        {
                          errors?.products?.[Index]?.varients?.[SIndex]
                            ?.double_variants?.[DIndex]?.price?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Stock</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder=" Stock"
                      {...register(
                        `products.${Index}.varients.${SIndex}.double_variants.${DIndex}.stock`,

                        {
                          required: " Stock is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        },
                      )}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];

                        // Allow only control keys and digits (0–9)
                        if (allowedKeys.includes(e.key) || /^\d$/.test(e.key)) {
                          return;
                        }

                        // Prevent decimal points or anything else
                        e.preventDefault();
                      }}
                    />
                    {errors?.products?.[Index]?.varients?.[SIndex]
                      ?.double_variants?.[DIndex]?.stock && (
                      <span className="text-danger">
                        {
                          errors?.products?.[Index]?.varients?.[SIndex]
                            ?.double_variants?.[DIndex]?.stock?.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Col>{" "}
              </>
            )}
            {Number(product_id?.variant_type_id) === variant_type.Triple && (
              <TripleVarientSection
                TripleVariants={dvariant?.Triple_Variants}
                product_id={product_id}
                Index={Index}
                SIndex={SIndex}
                DIndex={DIndex}
                control={control}
                register={register}
                getValues={getValues}
                errors={errors}
                setValue={setValue}
              />
            )}
          </Row>
        </div>
      ))}
    </>
  );
};

export default DoubleVarientSection;
